
sortOptions =
    participant: [
        {value: 'name',     label: 'Name'}
        {value: 'enrolled', label: 'Enrolled', desc: true}
        {value: 'edited',   label: 'Edited',   desc: true}
        {value: 'created',  label: 'Created',  desc: true}
    ]
    program: [
        {value: 'name',     label: 'Name'}
        {value: 'city',     label: 'City'}
        {value: 'id',       label: 'Program Id'}
    ]

getTagSkip = (tag, program) ->
    if tag.tag_for == 'participant' and program? then return 'program,location'
    else if tag.tag_for == 'program' then return 'participant'
    else return ""

class TagManagerController

    ### @ngInject ###
    constructor: ($scope, TagService) ->

        @TagService = TagService
        @entities = []
        @sortOptions = sortOptions[@tag.tag_for]
        @filters = {search: null, tags: {}}
        @skip = getTagSkip(@tag, @program)

        @noun = @tag.tag_for + 's'
        @Noun = @tag.tag_for[0].toUpperCase() + @tag.tag_for[1..] + 's'

        @sort = "name"
        $scope.$watch (=> @filters), (=> @refresh(true)), true

        @onlyTag = true
        @onlyTagOptions = [
            {value: false, name: 'All ' + @noun}
            {value: true,  name: 'In Tag'}
        ]

        $scope.$on('TagNotification.displayed', @refreshCounts)


    Object.defineProperties @::,
        showBulkAdd: get: -> (not @onlyTag) and @hasFilter and @counts?.false > 0
        showBulkRemove: get: -> @onlyTag and @counts?.true > 0
        showDeleteTag: get: -> @counts?.true == 0 and @onlyTag and not @hasFilter
        allowRedirect: get: ->
            @onlyTag and @counts.true == 0 and @counts.false > 0 and @tag.editable


    refresh: (redirect) =>
        @hasFilter = Object.keys(@filters.tags).length > 0 or @filters.search?.length > 0
        return @getEntities(sort: @sort, limit:10).then (response) =>
            @entities = response.data.items
            @totalCount = response.data.count
            @counts = response.data.counts
            if @allowRedirect and redirect
                @onlyTag = false
                return @refresh()

    refreshCounts: (extra) =>
        params = @getQueryParams(extra)
        return @TagService.getEntityCount(@tag, params).then (counts) =>
            @counts = counts
            @totalCount = counts[@onlyTag]
            return

    loadMore: =>
        last = @entities[@entities.length - 1].id
        return @getEntities(limit: 10, after: last, sort: @sort)
            .then (response) =>
                @entities.push response.data.items...
                return


    getQueryParams: (extra={}) ->
        params = angular.copy(@filters.tags)
        params.q = @filters.search
        params.only_tagged = @onlyTag
        angular.extend(params, extra)
        return params

    getEntities: (extra={}) =>
        params = @getQueryParams(extra)
        return @TagService.getEntities(@tag, params)

    changeSingle: (entity) =>
        if not @tag.editable then return
        return @TagService
            .setEntityTag(@tag, entity, not entity.has_tag)
            .then -> entity.has_tag = not entity.has_tag

    changeBulk: (remove) =>
        if not @tag.editable then return
        filters = angular.copy(@filters.tags)
        filters.q = @filters.search
        method = if remove then @TagService.untagFiltered else @TagService.tagFiltered
        return method(@tag, filters).then @refresh

    delete: ->
        @TagService.delete(@tag).then =>
            @onDelete(tag: @tag)

tagManagerComponent =
    controller: TagManagerController
    controllerAs: 'tagManager'
    templateUrl: 'tags/tagManager'
    bindings: tag: '=', onDelete: '&', program: '='

module.component 'tagManager', tagManagerComponent
